import { API_REQ_DISCLOSURE_LIST } from "@/types/apiModel/Disclosure/API_REQ_DISCLOSURE_LIST";
import { makeTimeRange } from "@/utils/makeTimeRange";

const DEFAULT_LIMIT_NUMBER = 100;

export default (p: API_REQ_DISCLOSURE_LIST, limit = DEFAULT_LIMIT_NUMBER) => `
      exchangeType: ${p.exchangeType}
      ${p.includeTinyKor ? `includeTinyKor : "${p.includeTinyKor}"` : ""}
      ${p.securityCode ? `securityCode: "${p.securityCode}"` : ""}
     ${
       p.categoryId
         ? `categoryId: [${p.categoryId?.map((v) => `"${v}"`).join(",")}]`
         : ""
     }
      ${makeTimeRange(p.baseDate)}
      limit: ${limit}
      page: ${p.page}
`;
